import { type UserAvatarProps } from './UserAvatar'
import { useUserAvatarSource } from './useUserAvatarSource'

type UseUserAvatarProps = Partial<UserAvatarProps> & { userId?: string }

export const useUserAvatarProps = ({ userId, ...overrides }: UseUserAvatarProps): UserAvatarProps => {
  const { imageUrl, initialLetters } = useUserAvatarSource({ userId })

  return {
    ...(imageUrl ? { imageUrl } : { useInitials: true, initialLetters }),
    ...overrides,
  }
}
